import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/layout/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Channels } from './pages/Channels';
import { Courses } from './pages/Courses';
import { CalendarPage } from './pages/Calendar';
import { Payments } from './pages/Payments';
import { Users } from './pages/Users';
import { UserCard } from './pages/UserCard';
import { Kicks } from './pages/Kicks';
import { PaymentMethods } from './pages/PaymentMethods';
import { Settings } from './pages/Settings';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/channels" element={<Channels />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/:id" element={<UserCard />} />
          <Route path="/kicks" element={<Kicks />} />
          <Route element={<ProtectedRoute minRank={20} />}>
            <Route path="/payment-methods" element={<PaymentMethods />} />
          </Route>
          <Route element={<ProtectedRoute minRank={30} />}>
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
